import { type DocumentImage } from '~/gql/graphql'

import { findByPath } from '../../../generals'
import {
  type FigureInfoKey,
  figureInfoKeyLabelI18nKeyMap,
} from '../../figureInfo'
import {
  getOldKeyForFigureInfoKey,
  resolveToEnglishKey,
} from '../resolveToEnglishKey'

/**
 * DocumentImage からメタデータの値を取得します。
 *
 * @param documentImage - DocumentImage。
 * @param figureInfoKey - FigureInfoKey。
 * @returns メタデータの値。
 */
export function getMetaValue(
  documentImage: App.PickGraphQL<DocumentImage, 'allMetadata'>,
  figureInfoKey: FigureInfoKey,
): string | undefined {
  const newKey = figureInfoKeyLabelI18nKeyMap[figureInfoKey]
  const oldKey = getOldKeyForFigureInfoKey(figureInfoKey)

  // 1. 新キーで検索（新データ用）
  const newResult = findByPath(documentImage.allMetadata, 'name', newKey)
  if (newResult) {
    return newResult.value
  }

  // 2. 既存データ対応: 翻訳値を正規化して旧キーと比較
  for (const meta of documentImage.allMetadata) {
    const normalizedName = resolveToEnglishKey(meta.name)
    if (normalizedName === oldKey) {
      return meta.value
    }
  }

  return undefined
}
